var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-autocomplete',{attrs:{"value":_vm.value,"autocomplete":_vm.autocomplete,"label":_vm.$t('value'),"required":"","dense":"","hide-details":""},on:{"input":function($event){return _vm.$emit('item-selected', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }